// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back[data-v-0b7c4217] {\n  width: auto;\n  padding: 13px 22px !important;\n}\n.back .back-icon[data-v-0b7c4217] {\n  -webkit-transform: rotateZ(90deg);\n          transform: rotateZ(90deg);\n}\n.disabled[data-v-0b7c4217] {\n  background-color: #9EABED;\n  border-radius: 4px;\n}\n.disabled[data-v-0b7c4217]:hover {\n  cursor: not-allowed;\n}", ""]);
// Exports
module.exports = exports;
